import {Box, Typography as Typo, styled, TypographyProps} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {SurveyCheckGreen} from '@jobseeker/lotus/assets/icons';
import {AppState} from '@jobseeker/common-core/types';
import {shallowEqual, useSelector} from 'react-redux';

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

interface VerificationProps {
  toggleNumberDialog: () => void;
  toggleDisableDialog: () => void;
}

export const VerificationComponent = ({
  toggleNumberDialog,
  toggleDisableDialog,
}: VerificationProps) => {
  const {profile} = useSelector((state: AppState) => state.user, shallowEqual);
  const maskedPhone = profile.phone ? profile.phone.slice(-3) : '';

  return (
    <Box maxHeight={'calc(80vh - 60px)'} mt={1} borderRadius={2}>
      <Box
        sx={{
          paddingTop: {xxs: 2, md: 2},
          paddingLeft: {xxs: 1.5, md: 2},
          paddingRight: {xxs: 1.5, md: 2},
          paddingBottom: {xxs: 2, md: 2},
          background: '#91B87929',
        }}
        display={'flex'}
        justifyContent={'flex-start'}
      >
        <Box mt={0.625}>
          <Image
            src={SurveyCheckGreen}
            width={32}
            height={32}
            alt="successIcon"
          />
        </Box>
        <Box display={'flex'} flexDirection={'column'} ml={1.625}>
          <Typography variant="subtitle2" color={'text.primary'}>
            2-step verification has enabled
          </Typography>
          <Typography
            variant="subtitle3"
            color="var(--Grey-font-Color, #7E7E7E)"
          >
            {`Each time you log in to your iimjobs account, you’ll be asked for
            your password and a verification code will be sent to your mobile
            number ending with ${maskedPhone}`}
          </Typography>
          <Box sx={{display: {xxs: 'block', md: 'flex'}}} mt={'12px'}>
            <Typography
              variant="subtitle3"
              color="var(--Grey-font-Color, #7E7E7E)"
            >
              Want to update your number?&nbsp;
            </Typography>
            <Typography
              onClick={toggleNumberDialog}
              sx={{
                padding: '0px',
                fontSize: '12px',
                fontWeight: '500',
                color: 'var(--brand-color, #49966E)',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              Change Number
            </Typography>
          </Box>
          <Box sx={{display: {xxs: 'block', md: 'flex'}}} mt={'8px'}>
            <Typography
              variant="subtitle3"
              color="var(--Grey-font-Color, #7E7E7E)"
            >
              Want to disable 2-step verification?&nbsp;
            </Typography>
            <Typography
              onClick={toggleDisableDialog}
              sx={{
                padding: '0px',
                fontSize: '12px',
                fontWeight: '500',
                color: 'var(--brand-color, #49966E)',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              Disable
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
